<template>
  <b-row  v-loading="loading"
    :element-loading-text="'Please wait...'"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">


      <sweet-modal icon="info" ref="redeemCode" title="Redeem Code" modal-theme="dark">
	            You can redeem a code here to get a yearly subscription for free if you have a code from one of our partners.

              <b-form>

                <b-form-input v-model="new_code" placeholder="Enter Code" ></b-form-input>

              </b-form>

              
               
               <template slot="button" >

                   <vue-loaders-ball-beat v-if="loading" color="red" scale="1"></vue-loaders-ball-beat>

                    <b-button :disabled="loading || new_code.length<2" variant="danger" @click="sendCode">Redeem Code</b-button> &nbsp;

	           </template>

            </sweet-modal>


            <b-tabs class="margin-top-default-content bg-dark">


              <b-tab title="Information" style="width: 90vw" class="bg-dark">


                <b-card class="bg-dark">
                  <template slot="header">
                    <h4>Account Information</h4>
                  </template>

                  <ul>

                      <li><b>Currency:</b> {{subscriptionInfo.currency}}</li>
                      <li><b>Subscription Status: </b>{{subscriptionInfo.subscription_status==0?'OK': 'Suspended'}}</li>
                      <li><b>Subscription Credits:</b> {{subscriptionInfo.available_credits}}</li>
                      <li><b>Subscription Renewal:</b> {{subscriptionInfo.next_due_date | moment("dddd, MMMM Do YYYY")}}</li>
                      <li><b>Subscription Package:</b> {{subscriptionInfo.package.title}}</li>
                      <li><b>Subscription Price:</b> {{subscriptionInfo.package.package_price_usd}} USD</li>
                  </ul>

              </b-card>
              </b-tab>

            <b-tab title="My Bills" style="width: 90vw" class="bg-dark">


              <p v-if="bills.length<1">No Pending Bills to Show</p>

              <b-col md="4" v-for="item in bills" key="item.id">
              <b-card class="bg-dark">
              <template slot="header">
                <h4>Invoice for {{item.currency}} {{item.total_amount}} </h4>
              </template>

              <ul>

                  <li>Due Date:  {{ item.due_date?item.due_date: item.due_date| moment("dddd, MMMM Do YYYY") }}</li>
                  <li v-if="item.is_overdue">Overdue</li>
                  <li>Payment period: {{item.bill_month}}</li>
              </ul>


              <template slot="footer">
                <b-button @click="getPaymentLink(item.id)"  :variant="!item.is_overdue?'primary':'danger'"  style="width: 100%;">Make Payment</b-button>
              </template>
          </b-card>
        </b-col>

            </b-tab>

            <b-tab title="Payment History" style="width: 90vw" class="bg-dark">

              <b-col md="4" v-for="item in bills_paid" key="item.id">
              <b-card class="bg-dark">
              <template slot="header">
                <h4>Invoice for {{item.currency}} {{item.total_amount}} </h4>
              </template>

              <ul>

                  <li>Due Date:  {{ item.due_date?item.due_date: item.due_date| moment("dddd, MMMM Do YYYY") }}</li>
                  <li v-if="item.is_overdue">Overdue</li>
                  <li>Payment period: {{item.bill_month}}</li>
              </ul>


              
          </b-card>
        </b-col>
              

            </b-tab>
 
            <b-tab title="Plans" style="width: 90vw" class="bg-dark" v-if="false">

              <p>Please note that package changes will be effected at the end of the billing period. You will be charged the new price when your subscription renews. Downgrading a package will lead to loss or deletion of some of your current services if they are not available in the lower package.</p>

              <b-col md="4" v-for="item in packages" key="item.id">
              <b-card class="bg-dark">
              <template slot="header">
                <h4>{{item.title}} USD {{item.package_price_usd}} per month</h4>
              </template>

              <ul>

                  <li>{{item.package_features.crm}} image edits per month</li>
                  <li>{{item.package_features.bots}} Image optimizations per month</li>
                  <li>{{item.package_features.sites}} Object Removals per month</li>
                 
                  
                  <li>Image Composites</li>
                  <li>Text Addition Filters</li>
              </ul>

              <template slot="footer">
                <b-button @click="accountUpdate(item.id)" :disabled="item.is_active" variant="primary"  style="width: 100%;">{{!item.is_active?'Request': 'Currently Active'}}</b-button>
              </template>
          </b-card>
        </b-col>

            </b-tab>

            <b-tab title="Redemptions" style="width: 90vw" class="bg-dark">

              <p>Redeem your codes here</p>

              <br>

              <b-button @click="activateCodeModoal" variant="primary">Redeem Code</b-button>

              <br><br>



              <p v-if="redemptions.length<1">No Redemptions to Show</p>

              <b-col md="4" v-for="item in redemptions" key="item.id">
              <b-card class="bg-dark">
              <template slot="header">
                <h4>Redemption Code: {{item.code}} </h4>
              </template>

              <ul>

                  <li>Redeemed on:  {{ item.redeemed_at?item.redeemed_at: item.redeemed_at| moment("dddd, MMMM Do YYYY") }}</li>
                  <li>Expiry Date: {{ new Date(item.expires_at_ts * 1000) |moment("dddd, MMMM Do YYYY") }}</li>
              </ul>

          </b-card>

        </b-col>

            </b-tab>

            </b-tabs>


     

  </b-row>
</template>

<script>
import {createItemJsonPost, getTableData} from '../../services/v1/api_store'
import {DEFAULT_TOAST} from '../../services/v1/constants';

const opts =  DEFAULT_TOAST;

export default {
  name: 'Account',

  mounted () {

      let self = this;
      
      this.isTrial = this.$store.getters.getisTrial

      getTableData(this.$store, `users/packages/list`, text => self.handleDataLoaded(text));

      getTableData(this.$store, `users/subscription/redemptions`, text => self.handleRedemptionsDataLoaded(text));

      getTableData(this.$store, `users/bills/unpaid`, text => self.handleDataUnpaidLoaded(text));

      getTableData(this.$store, `users/bills/paid`, text => self.handleDatapaidLoaded(text));
  },
  methods: {

      handleRedemptionsDataLoaded(resp) {
        this.redemptions = resp.response.redeemed_codes;
        this.subscriptionInfo = resp.response.subscription;
      },
      handleDataLoaded (resp) {
        console.log(resp);
        this.packages = resp.response.packages;
        this.loading = false;
      }, 
      handleDataUnpaidLoaded (resp) {
        this.bills = resp.response.bills;
        this.loading = false;
      },
      handleDatapaidLoaded (resp) {
        this.bills_paid = resp.response.bills;
        this.loading = false;
      },
      handlePaymentDataLoaded (resp) {
        const payment_link = resp.response.payment_link;
        this.loading = false;
        window.open(payment_link, "_blank");
    
      },
      activateCodeModoal () {
          this.showNested = true;
          this.$refs.redeemCode.open();
      },

      getPaymentLink (invoiceid) {

        this.loading = true;


        getTableData(this.$store, `users/invoices/${invoiceid}/pay`, text => this.handlePaymentDataLoaded(text));

          
          /*if (cmd === 'upgrade') {
              this.$router.push('/payment');
              return
          }
          
          this.loading = true;

          createItemJsonPost(
            this.$store,
            "users/accounts/update",
            {
                packageid: packageid,
                "userid": this.$store.getters.getCurrentUserId,
                }, text => this.onUpdateComplete(text)
            );*/
      },

      sendCode() {
        this.loading = true;

        createItemJsonPost(
          this.$store,
          "users/subscription/redeem",
          {
              code: this.new_code,
              "userid": this.$store.getters.getCurrentUserId,
              }, text => this.onRedeemComplete(text)
          );
      },

      onRedeemComplete (resp) {
        if(resp.code ===200){
          this.$toasted.show('Redemption Successful', opts);
          this.$refs.redeemCode.close();

          let self = this;

          getTableData(this.$store, `users/subscription/redemptions`, text => self.handleRedemptionsDataLoaded(text));
        }
        else {
          this.$toasted.show('Redemption Failed, try again', opts);
        }

        this.loading = false;
      },

      onUpdateComplete (resp) {
       if(resp.code ===200){
         
         this.$toasted.show('Update Successful', opts);

         this.$store.commit('setIsTrial', true); 

         this.isTrial = true;

         this.$refs.trialModal.close();

       }
       else {
         this.$toasted.show('Confirmation Failed, try again', opts);
       }

       this.loading = false;
     }
  },
  data () {
    return {
      isTrial: false,
      loading: true,
      packages: [],
      bills: [],
      bills_paid: [],
      redemptions: [],
      new_code: '',
      showNested: false,
      subscriptionInfo: {}
    }
  },
}
</script>
